export class Sanierungsdaten {
  sanierungsdatenAbgefragt = false;
  dachbedeckung: boolean | null;
  dachbedeckungJahr: number | null;
  rohreGebaeude: boolean | null;
  rohreGebaeudeJahr: number | null;
  rohreAusserhalb: boolean | null;
  rohreAusserhalbJahr: number | null;
  leitungenElektrik: boolean | null;
  leitungenElektrikJahr: number | null;
  leitungenHeizung: boolean | null;
  leitungenHeizungJahr: number | null;
  kernsanierungDurchgefuehrt = false;
  kernsanierungsjahr: number | null | undefined; // null/undefined für Ergebnis aus Sanierungsservice ermöglichen

  constructor() {
    this.dachbedeckung = null;
    this.dachbedeckungJahr = null;
    this.rohreGebaeude = null;
    this.rohreGebaeudeJahr = null;
    this.rohreAusserhalb = null;
    this.rohreAusserhalbJahr = null;
    this.leitungenElektrik = null;
    this.leitungenElektrikJahr = null;
    this.leitungenHeizung = null;
    this.leitungenHeizungJahr = null;
  }
}
